@if (onlyList) {
  <app-list-filter-items
    [readonly]="readonly"
    [queryFilters]="queryFilters"
    [objectType]="objectType"
    [filterRows]="filterRows"
    [newFilterFields]="newFilterFields"
    [recordResults]="recordResults"
    [listStyle]="listStyle"
    [autocompleteSearchOpts]="autocompleteSearchOpts$"
    [allowRelatedObjectFields]="allowRelatedObjectFields"
    (autocompleteSearchChanged)="onAutocompleteSearch($event)"
    (filterFieldSelected)="filterFieldSelected($event)"
    (filterValueChange)="filterValueChange($event)"
    (onRecordSearchChange)="onRecordSearchChange($event)"
    (autocompleteRecord)="autocompleteRecord($event)"
    (removeFilter)="removeFilter($event)"
    (filterUpdated)="filterUpdated()"
    (filterRowsValidityChange)="onFilterRowsValidityChange($event)"
  ></app-list-filter-items>
  <div>
    <ts-button [disabled]="readonly" type="flat" color="basic" icon="add" (click)="addFilterRow()">
      Add filter
    </ts-button>
  </div>
} @else {
  <div class="flex items-center" [ngStyle]="{ 'width.px': searchBarDimensions.width }">
    <mat-form-field class="w-full treo-mat-dense treo-mat-no-subscript">
      @if (label) {
        <mat-label>{{ label }}</mat-label>
      }
      @if (this.filterRows.length === 0) {
        <mat-icon matPrefix [svgIcon]="'search'"></mat-icon>
      }
      <mat-chip-list #chipList>
        @for (filter of this.filterRows | slice: 0 : 2; let i = $index; track filter.field?.name) {
          <mat-chip [removable]="removable" (removed)="removeFilter(i)">
            {{ maxFieldName(filter?.field?.name) || maxFieldName(filter.q) }}
            @if (removable) {
              <mat-icon matChipRemove>cancel</mat-icon>
            }
          </mat-chip>
          @if (this.filterRows[2]) {
            <mat-chip (click)="openFiltersPanel()">...</mat-chip>
          }
        }
        <input
          matInput
          [matChipInputFor]="chipList"
          [formControl]="searchInputControl"
          [autocomplete]="'off'"
          [placeholder]="placeholder"
          data-cy="search-filter-input"
        />
      </mat-chip-list>
      <button
        class="expand-filter-button"
        mat-button
        matSuffix
        mat-icon-button
        aria-label="Expand"
        (click)="openFiltersPanel()"
        #filterPanelOrigin
      >
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </mat-form-field>
  </div>
}

<!-- Filters Panel -->
<ng-template #filterPanel>
  <div class="filters" #filters>
    <div class="add-filters-row">
      <div class="filters-title">
        <mat-icon class="icon-size-20 rotate-90 mirror" [svgIcon]="'tune'"></mat-icon>
        Filters
        <span class="spacer"></span>
        <button class="discard-button" mat-stroked-button type="button" [disabled]="!canClearFilters" (click)="clear()">
          <span>Clear</span>
        </button>

        @if (!hideSaveButton) {
          <button
            class="save-button"
            mat-stroked-button
            data-cy="save-filter-button"
            (click)="applyFilterAndSave()"
            [disabled]="!canSaveFilter"
          >
            <mat-icon [svgIcon]="'save'"></mat-icon>
            <span>Save</span>
          </button>
        }
        @if (canRunFilter) {
          <button class="send-button" mat-flat-button type="submit" [color]="'primary'" (click)="applyFilter()">
            <span>Run</span>
          </button>
        }
      </div>

      <!-- Saved Filters Name -->
      @if (!hideFilterName) {
        <div class="filter-name-row">
          <mat-form-field class="flex-auto">
            <mat-label>Filter Name{{ savedFilter?.name.length ? '' : ' (required to save)' }}:</mat-label>
            <input matInput [value]="savedFilter?.name" (input)="filterNameChange($event.target.value)" />
          </mat-form-field>
          @if (savedFilter?.id) {
            <button mat-icon-button (click)="deleteFilters()">
              <mat-icon [svgIcon]="'delete'"></mat-icon>
            </button>
          }
        </div>
      }

      <!-- Include child toggle -->
      @if (allowIncludeChildren) {
        <div class="toggle-child-row">
          <mat-slide-toggle
            #includeChildrenToggle
            [matTooltip]="
              'Include child records in search' +
              (disableIncludeChildrenToggle ? ' (only available when query search and/or filters are filled)' : '')
            "
            [color]="'primary'"
            [checked]="queryFilters.includeChildren"
            [disabled]="disableIncludeChildrenToggle"
            [labelPosition]="'before'"
            (change)="toggleIncludeChildren($event.checked)"
          >
            <span style="font-size: 14px; font-weight: 400">Include children: </span>
          </mat-slide-toggle>
        </div>
      }

      <app-list-filter-items
        [queryFilters]="queryFilters"
        [objectType]="objectType"
        [filterRows]="filterRows"
        [newFilterFields]="newFilterFields"
        [recordResults]="recordResults"
        [typeaheadResults]="typeaheadResults"
        [autocompleteSearchOpts]="autocompleteSearchOpts$"
        (autocompleteSearchChanged)="onAutocompleteSearch($event)"
        [allowRelatedObjectFields]="allowRelatedObjectFields"
        (filterFieldSelected)="filterFieldSelected($event)"
        (filterValueChange)="filterValueChange($event)"
        (onRecordSearchChange)="onRecordSearchChange($event)"
        (onTypeaheadSearchChange)="onTypeaheadSearchChange($event)"
        (autocompleteRecord)="autocompleteRecord($event)"
        (autocompleteTypeahead)="autocompleteTypeahead($event)"
        (removeFilter)="removeFilter($event)"
        (filterUpdated)="filterUpdated()"
        (filterRowsValidityChange)="onFilterRowsValidityChange($event)"
      ></app-list-filter-items>
      <div>
        <button class="add-email-field" type="button" mat-icon-button (click)="addFilterRow()" matTooltip="Add Filter">
          <mat-icon [svgIcon]="'add_circle'"></mat-icon>
        </button>
      </div>
    </div>
  </div>
</ng-template>
